import { render, staticRenderFns } from "./BlackMicropointV2.vue?vue&type=template&id=ac79a508&scoped=true"
import script from "./BlackMicropointV2.vue?vue&type=script&lang=js"
export * from "./BlackMicropointV2.vue?vue&type=script&lang=js"
import style0 from "./BlackMicropointV2.vue?vue&type=style&index=0&id=ac79a508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac79a508",
  null
  
)

export default component.exports